import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=5ecf4c58&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"
import style0 from "./banner.vue?vue&type=style&index=0&id=5ecf4c58&prod&lang=scss&scoped=true"
import style1 from "./banner.vue?vue&type=style&index=1&id=5ecf4c58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_398719d9ba0fb65ce1cea3b2910bec76/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecf4c58",
  null
  
)

export default component.exports